<template>
    <div v-if="(selectedPlano && (dados))" id="register-store" class="pricing-table w-100">
        <div class="pricing-item pricing-featured col-10 m-0 p-0 col-md-11 m-auto">
            <div class="pricing-title pt-3 pb-5">
                <span><i class="fa fa-shopping-cart"></i> Carrinho</span>
            </div>
            <div class="pricing-value py-2 pb-5">
                <p class="m-0" v-if="selectedPlano">{{selectedPlano.nome}}</p>
                <p class="smallText text-right pr-5">
                    {{recorrencia}}
                    <animated-number style="font-size: 16px" :value="(dados.selected.planoValor)"
                        :formatValue="formatMoney" :duration="300" />
                </p>
                <hr class="my-2" v-show="dados.selected.adicionais.length">
                <div class="row mx-0 my-2 justify-content-around" v-for="(item, i) in dados.selected.adicionais" :key="i">
                    <div class="col p-0">
                        <p class="undertext m-0 text-right">
                            <span>{{item.quantidade}}x {{item.title}}
                                <p class=" m-0 "> {{formatMoney(item.valor)}}</p>
                            </span>
                        </p>
                    </div>
                    <div class="px-3 text-red">
                        <span class="h-100 d-flex align-items-center">
                            <i @click="removeItem(item.id)" class="fa fa-trash-o" style="font-size: 20px"></i>
                        </span>
                    </div>
                </div>
                <hr class="my-2">
                <animated-number :value="valueFinal" :formatValue="formatMoney" :duration="300" />
                <span class="smallText small">/{{abrev}}</span>
                <div v-if="dados.selected.adicionais.length" class="d-flex justify-content-center">
                    <button @click="removeItem(null)" class="btn btn-outline-danger py-0">Limpar</button>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['selectedPlano', 'dados'],
        data() {
            return {
                abrev: 'Mês'
            }
        },
        beforeMount() {
            (this.formatMoney = this.formatMoney.bind(this));
        },
        computed: {
            recorrencia() {
                if (this.selectedPlano) {
                    let plano = this.selectedPlano.recorrencias.find(x => x.id == this.dados.selected.fk_validade_id);
                    if (plano) {
                        return plano.nome
                    }
                }
                return '';
            },
            adicionais() {
                return this.$store.state.plano.adicionais;
            },
            valueFinal() {
                let valor = parseFloat(this.dados.selected.planoValor);
                if (!this.dados.selected.adicionais) {
                    return valor;
                }
                this.dados.selected.adicionais.map(item => {
                    valor += parseFloat(item.valor * item.quantidade);
                });
                return valor;
            }
        },
        beforeUpdate() {
            if (this.recorrencia == 'Mensal') return this.abrev = 'Mês'
            if (this.recorrencia == 'Trimestral') return this.abrev = 'Tri'
            if (this.recorrencia == 'Semestral') return this.abrev = 'Sem'
            if (this.recorrencia == 'Anual') return this.abrev = 'Ano'
        },
        methods: {
            removeItem(payload) {
                if (payload) {
                    let id = this.dados.selected.adicionais.findIndex(x => x.id == payload);
                    if (this.dados.selected.adicionais[id].quantidade > 1) {
                        this.dados.selected.adicionais[id].quantidade -= 1;
                    } else {
                        this.dados.selected.adicionais.splice(id, 1);
                    }
                } else {
                    this.dados.selected.adicionais = [];
                }
            },
        }
    }
</script>

<style scoped src="@/assets/sass/bootstrap4.css"></style>
<style scoped src="@/assets/sass/home.css"></style>
<style scoped lang="scss" src="./register.scss"></style>

<style scoped>
    .slide-fade-up-enter-active {
        transition: all 0.25s ease-in-out;
        transition-delay: 0.1s;
        position: relative;
    }

    .slide-fade-up-leave-active {
        transition: all 0.25s ease-in-out;
        position: absolute;
    }

    .slide-fade-up-enter {
        opacity: 0;
        transform: translateY(15px);
        pointer-events: none;
    }

    .slide-fade-up-leave-to {
        opacity: 0;
        transform: translateY(-15px);
        pointer-events: none;
    }
</style>